import React from 'react';
import Message from '../Common/Message';

const NotAuthorized = () => <Message content='You are not authorized to see this page.' />;

export default NotAuthorized;
